import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { putDataPromise } from 'brock-fetch-utils';
import { HorizontalFlex, PageActionMenu } from 'smartsuite-ui';
import DashboardContext from '../shared/hooks/dashboardContext';
import { useLabelContext } from '../shared/hooks/labelContext';

export default function LandingPageHeader(props) {
    const { dashboardLabels } = useLabelContext();
    const {
        uriConstants: { auditLogUri, pageHelpUri },
    } = useContext(DashboardContext);

    function onActionClick(description) {
        putDataPromise(auditLogUri, {
            message: `Page action selected on ${props.title}: ${description}.`,
        });
    }

    return (
        <div className="dashboard-header">
            <HorizontalFlex cssClassModifiers={['flex-wrap']}>
                <div className="dashboard-header__title-wrapper">
                    <HorizontalFlex cssClassModifiers={['flex-wrap']}>
                        <span className="dashboard-header__title">
                            {dashboardLabels[props.title] || props.title}
                        </span>
                    </HorizontalFlex>
                </div>
            </HorizontalFlex>
            <HorizontalFlex>
                <PageActionMenu
                    pageHelpUrl={pageHelpUri(props.onlineHelpId)}
                    onActionClick={onActionClick}
                />
            </HorizontalFlex>
        </div>
    );
}

LandingPageHeader.propTypes = {
    onlineHelpId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string.isRequired,
};

LandingPageHeader.defaultProps = {
    onlineHelpId: undefined,
};
